import React from 'react';
import { LinkAction } from '@leverege/molten/routes';
import { RelationshipBreadcrumbs } from '@leverege/molten/imagine';
import ItemScreenWrapper from "./ItemScreenWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const relationships = ['location', 'company.locations', 'organization.companies.locations'];
export default function processRelationship(molten, relationship) {
  if (relationships.includes(relationship.options.path)) {
    const path = `${relationship.urlPath}/:${relationship.blueprint.type}Id/alertRules`;
    molten.addPlugin('Action', LinkAction.create({
      id: `actions.${relationship.path}.alertRules`,
      icon: 'fa-solid fa-bell-exclamation',
      name: 'Alert Rules',
      path,
      matches: {
        use: 'navBar',
        client: 'ItemScreen',
        objectType: relationship.objectType,
        path: relationship.path
      },
      layout: {
        sort: 'e.2',
        sectionName: 'Location Management'
      }
    }));
    molten.addPlugin('Route', {
      id: `route.${relationship.path}.alertRules`,
      matches: {
        client: 'ItemScreen',
        objectType: relationship.objectType,
        path: relationship.path
      },
      path,
      render: props => {
        return /*#__PURE__*/_jsx(ItemScreenWrapper, {
          relationship: relationship,
          layout: "AlertRules",
          title: "Alert Rules",
          icon: "fa-solid fa-bell-exclamation",
          ...props
        });
      }
    });
    molten.addPlugin('Route', {
      id: `route.${relationship.path}.alertRules:breadcrumbs`,
      matches: {
        client: 'Breadcrumbs'
      },
      exact: true,
      path,
      render: ({
        match,
        ...rest
      }) => {
        const rel = relationship.createItem(match);
        const name = 'Alert Rules';
        const extraCrumbs = [{
          name,
          tooltip: name,
          url: path
        }];
        return /*#__PURE__*/React.createElement(RelationshipBreadcrumbs, {
          match,
          ...rest,
          extraCrumbs,
          relationship: rel
        });
      }
    });
  }
}